
import { MainSection } from '../components/faqPage/MainSection';

export function FaqPage() {
  return <MainSection />;
}
